import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { EnvironmentThemeProvider } from '@codex-brightworld/themes';

const BoldLabel = styled.span`
  @font-face {
    font-family: 'CurrysSans';
    src: url('https://currys-ssl.cdn.dixons.com/css/themes/fonts/currys/CurrysSans-Regular.woff') format('woff'),
        url('https://currys-ssl.cdn.dixons.com/css/themes/fonts/currys/CurrysSans-Regular.otf') format('truetype'),
        url('https://currys-ssl.cdn.dixons.com/css/themes/fonts/currys/CurrysSans-Regular.eot?') format('embedded-opentype');
  }

  background: ${(props) => props.theme.colors.neutral.grey[0]};
  color: ${(props) => props.theme.colors.neutral.currysBlack};
  padding: 0 0 20px;
  display: block;
  font-size: 18px;
  font-family: CurrysSans;
  
  @media ${(props) => props.theme.breakpoints.mobile} {
    padding: 0 0 16px;
  }
`;

const AttachmentsListHeader = ({ label }) => {
  if (!label) {
    return null;
  }

  return (
    <EnvironmentThemeProvider>
      <BoldLabel>
        {label}
      </BoldLabel>
    </EnvironmentThemeProvider>
  );
};

AttachmentsListHeader.propTypes = {
  label: PropTypes.string
};

AttachmentsListHeader.defaultProps = {
  label: null
};

export default AttachmentsListHeader;
